import { Sparkles } from 'lucide-react';

import { cn } from '../../../../lib/cn';

/** Dấu hiệu "AI làm" trên nút và tiêu đề, cùng biểu tượng với màn Phân công. */
export function IconAi({ className }: { className?: string }) {
  return <Sparkles aria-hidden className={cn('h-3.5 w-3.5', className)} />;
}
